/**
 * @file Stock页
 * @author yuanyaojia<yuanyaojia@baijia.com>
 * @date 2021-4-21
 */

import http from './http';
import constant from './constant';

/**
 * 获取股票基本信息
 * url: /stock/baseInfo.json
 * 方法：POST
 */

export const getStockInfo = params => http.post(constant.STOCK.GET_STOCK_INFO, params);

/**
 * 按分钟获取股票K线图
 * url: /stock/minute/kLine.json
 * 方法：POST
 */

export const getMinKLine = params => http.post(constant.STOCK.GET_MIN_K_LINE, params);

/**
 * 按时间段获取股票K线图
 * url: /stock/period/kLine.json
 * 方法：POST
 */

export const getPeriodKLine = params => http.post(constant.STOCK.GET_PERIOD_K_LINE, params);

